const NFilteredSitePlansToShow={All:0, One:1, Two:2, };
export default NFilteredSitePlansToShow;